<template>
  <CommonPages id="home" classs="home ">
    <div :class="`cover-banner cover-banner-${deviceType} cover-banner-${domainConfig.BGNUM}`" />
    <section class="home-container">
      <div class="page-head-row">
        <div class="page-head">
          {{ domainConfig.IAmTitle }}
        </div>
        <AdComponent v-if="deviceType == 'mobile' " ref="ads-home-1"
          class="ads-insert pc_padding padding-horizon-24" :ads="adsensConfig.home_1"
          :showDebug="showDebug" />
        <div class="page-head-slish" />
        <div class="page-head-sub-head">
          {{ activeTag?activeTag:domainConfig.IAmSubTitle }}
        </div>
      </div>

      <div class="home-body-container">
        <div class="home-list-row">
          <template v-for="(data,i) in wikiList">
            <a :key="`list_item_${i}`" class="home-list-item cursor"
              :href="generateWikiUrl(data.id, data.title, data.category)">
              <div v-if="deviceType != 'mobile'" class="home-list-item-img">
                <img :src="data.thumbnailImgUrl" alt="">
              </div>

              <div class="home-list-item-common-row">
                <div class="home-list-item-title">
                  {{ data.title }}
                </div>
                <div v-if="deviceType == 'mobile'" class="home-list-item-img">
                  <img :src="data.thumbnailImgUrl" alt="">
                </div>
                <div class="home-list-item-content" v-html="data.summary" />
                <div class="homelist-item-content-btn-row cursor">
                  Read More <img src="@/assets/icon-arrow.png" alt="">
                </div>
              </div>
            </a>
            <AdComponent v-if="shouldInsertAd(i) !== -1" :key="`ad_${i}`" :ref="'ads-home-card' + i"
              class="ads-insert padding-horizon-24 "
              :ads="adsensConfig?.home_recommand?.[shouldInsertAd(i)]" :showDebug="showDebug" />
          </template>

          <div v-if="deviceType != 'mobile' && hasNext" class="load-more">
            Load More
          </div>
        </div>
        <div v-if="deviceType != 'mobile'" class="home-tags-row">
          <div class="tags-title">
            Tags
          </div>
          <div class="tag-row">
            <a v-for="(data,i) in tagList" :key="`tag_${i}`" class="tags-item cursor"
              :class="{'active':activeTag == data}" :href="generateTagUrl(data)">
              {{ data }}
            </a>
          </div>
        </div>
      </div>
    </section>
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js';
import { mapGetters } from 'vuex';
import AdComponent from '@/pages/components/AdComponent.vue'
import CommonPages from '@/pages/components/pc_common.vue'

import '@/css/home.scss'

export default {
  name: 'Home',
  components: {
    AdComponent,
    CommonPages,

  },
  mixins: [common],
  data () {
    return {
      // wikiList: [],
      // tagList: [],

      page: 1,   // 当前页数
      hasNext: false,
      activeTag: null,

      ////////
    };
  },
  metaInfo () {
    return {
      title: `${this.domainConfig['meta'].title}`,
      meta: [
        {
          name: 'description',
          content: `${this.domainConfig['meta'].des}`,
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "adsensConfig",
      'adPosConfig',
      'wikiList',
      'tagList',
    ])
  },
  created () {
    const { tags } = this.$route.params
    // console.log(`tags:${tags}`);
    this.activeTag = tags
  },
  async activated () {
    console.log(`${this.$options.name} Component activated-----------`);
  },
  async mounted () {
    console.log(`-------------------${this.$options.name} mounted`)
    console.log(this.domainConfig['type']);

    if (!this.tagList.length) {
      this.getTagList();
    }
    if (!this.wikiList.length) {
      await this.getWikiList();
    }
    this.loadAdSenseScript();  // 重新加载广告脚本
    this.watchForIframeInsertion()

    // 使用防抖包装滚动事件
    this.onScroll = this.debounce(this.onScroll.bind(this), 300);
    // 监听滚动事件
    window.addEventListener('scroll', this.onScroll);
  },
  deactivated () {
    console.log(`${this.$options.name} Component deactivated-----------`);
  },
  beforeDestroy () {
    console.log(`-------------------${this.$options.name} beforeDestroy`);
    // 组件销毁时移除滚动事件监听
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    //客户端监听
    watchForIframeInsertion () {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.tagName === 'IFRAME' && node.closest('ins.adsbygoogle')) {
              this.setupIframeTracking(); // 在检测到广告 iframe 插入后，调用 setupIframeTracking
            }
          });
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
    },
    setupIframeTracking () {
      // let _this = this;
      console.log('ready to track iframe');
      const iframes = document.querySelectorAll('iframe');
      const tracker = new this.IframeTracker(this);
      iframes.forEach((iframe) => {
        tracker.addIframe(iframe, (iframeElement) => {
          console.log('Iframe 点击触发了!', iframeElement);
          const adContainer = iframeElement.closest('ins.adsbygoogle');

          if (adContainer) {
            // 获取父级 ins 元素的边界矩形
            const insRect = adContainer.getBoundingClientRect();

            // 计算父级 ins 元素相对于页面左上角的位置和高度
            const insX = insRect.left;
            const insY = insRect.top;
            const insHeight = insRect.height;

            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;

            let transformData = {
              insX: insX,
              insY: insY,
              insHeight: insHeight,
              windowWidth: windowWidth,
              windowHeight: windowHeight,
            }
            this.$adClick(JSON.stringify(transformData))
            tracker.trackEvent('ad_iframe_click', 'click', {
              'data-ad-slot': adContainer.dataset.adSlot,
            });
          }
        });
      });
    },
    IframeTracker: class {
      constructor(vues, resolution = 200) {
        this.vues = vues; // 保存 Vue 实例
        this.resolution = resolution;
        this.iframes = [];
        this.interval = null;
        this.activeIframe = null; // 存储最近被点击的iframe
        this.setupVisibilityTracking();
      }

      addIframe (element, callback) {
        const adContainer = element.closest('ins.adsbygoogle');
        const iframe = {
          element: element,
          callback: callback,
          hasTracked: false,
          adSlot: adContainer ? adContainer.dataset.adSlot : null,
        };
        this.iframes.push(iframe);

        if (!this.interval) {
          this.interval = setInterval(() => this.checkClick(), this.resolution);
        }
      }

      checkClick () {
        const activeElement = document.activeElement;
        if (activeElement) {
          this.iframes.forEach((iframe) => {
            if (activeElement === iframe.element && !iframe.hasTracked) {
              iframe.callback(iframe.element);
              iframe.hasTracked = true;
              this.activeIframe = iframe; // 更新最近被点击的iframe
            }
          });
        }
      }

      setupVisibilityTracking () {
        const hiddenProperty =
          'hidden' in document ? 'hidden' : 'webkitHidden' in document ? 'webkitHidden' : 'mozHidden' in document ? 'mozHidden' : null;
        const visibilityChangeEvent = hiddenProperty.replace(/hidden/i, 'visibilitychange');

        const onVisibilityChange = () => {
          if (!document[hiddenProperty]) {
            console.log('页面激活状态,返回页面?');
            this.activeIframe = null; // 重置最近被点击的iframe记录
          } else {
            console.log('页面非激活状态');

            if (this.activeIframe) {
              // 上报逻辑
              this.trackEvent('ad_iframe_click_leave', 'click', {
                'data-ad-slot': this.activeIframe.adSlot,
              });
            }
          }
        };

        this.iframeVisibilityTracker = onVisibilityChange;
        document.addEventListener(visibilityChangeEvent, this.iframeVisibilityTracker);
      }

      trackEvent (eventName, eventValue, dataAttributes) {
        // 事件追踪逻辑
        console.log(`${eventName} with value ${eventValue} on`, dataAttributes);

        this.vues.$eventrack(eventName, eventValue, {
          ...dataAttributes,
        });
      }
    },
    //shuju
    async getTagList () {
      try {
        const res = await this.$global.server.getTagList({ type: this.domainConfig['IAmType'] })
        console.log(res)
        if (res.code == 200) {
          let data = res.data
          this.tagList.push(...data)
        }
      } catch (err) {
        console.log(err)
      }
    },
    async getWikiList () {
      const params = {
        type: this.domainConfig['IAmType'],
        pageNum: this.page,
        pageSize: 20,
      };
      if (this.activeTag) {
        params.category = this.activeTag
      }

      try {
        const res = await this.$global.server.getWikiList(params)
        console.log(res)
        if (res.code == 200) {
          let data = res.data.popularizations
          this.wikiList.push(...data)
          this.hasNext = res.data.hasNext
          this.page++;
        }
      } catch (err) {
        console.log(err)
      }
    },
    chooseTag (tag) {
      // 显示插屏广告
      console.log('触发跳转前显示插屏广告: chooseTag方法');
      this.showInterstitial();

      // 保留原有逻辑不变
      const currentParams = this.$router.currentRoute.params; // 当前路由的 params
      const currentQuery = this.$route.query; // 当前路由的 query

      const channel = currentParams.channel ? `/${currentParams.channel}` : ''; // 拼接 channel path
      const queryString = new URLSearchParams(currentQuery).toString(); // 转换 query 对象为字符串
      const fullQueryString = queryString ? `?${queryString}` : ''; // 如果有查询参数，拼接为 ?xxx=yyy 格式

      window.location.href = `${channel}/${tag}${fullQueryString}`
    },
    chooseWiki (id, name, cate) {
      // 显示插屏广告
      console.log('触发跳转前显示插屏广告: chooseWiki方法');
      this.showInterstitial();

      // 保留原有逻辑不变
      console.log(id, name);
      const currentParams = this.$router.currentRoute.params; // 当前路由的 params
      const currentQuery = this.$route.query; // 当前路由的 query

      const channel = currentParams.channel ? `/${currentParams.channel}` : ''; // 拼接 channel path
      const queryString = new URLSearchParams(currentQuery).toString(); // 转换 query 对象为字符串
      const fullQueryString = queryString ? `?${queryString}` : ''; // 如果有查询参数，拼接为 ?xxx=yyy 格式

      window.location.href = `${channel}/${cate.replace(/\s+/g, '-')}/${id}/${name.replace(/\s+/g, '-')}${fullQueryString}`
    },
    // 防抖函数
    debounce (func, delay) {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          func.apply(this, args);
        }, delay);
      };
    },
    onScroll () {
      // 获取文档的总高度
      const documentHeight = document.documentElement.scrollHeight;
      // 当前滚动的高度
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      // 视口的高度
      const windowHeight = window.innerHeight;

      // 当滚动距离接近底部2000px时触发
      if (scrollTop + windowHeight >= documentHeight - 2000) {
        console.log('加载');
        this.getWikiList();
      }
    },
    //广告相关start
    shouldInsertAd (index) {
      console.log(this.adPosConfig);
      // 判断是否应该插入广告的位置
      const position = index + 1;
      const adIndex = this.deviceType == 'mobile' ? this.adPosConfig.homeRecommand.indexOf(position) : this.adPosConfig.homeRecommandPC.indexOf(position);

      /// 返回广告在 homeAD 中的索引，如果不在配置中则返回 -1
      return adIndex !== -1 ? adIndex : -1;
    },
    shouldDetailInsertAd (index) {
      // 判断是否应该插入广告的位置
      const position = index + 1;
      const adIndex = this.adPosConfig.detail.indexOf(position);

      /// 返回广告在 homeAD 中的索引，如果不在配置中则返回 -1
      return adIndex !== -1 ? adIndex : -1;
    },
    async loadAdSenseScript () {
      // 检查是否已加载GPT脚本
      if (window.googletag && window.googletag.apiReady) {
        console.log("GPT脚本已加载完成");
        this.$eventrack('adscript_loaded', 'expose');
        this.observeAds();
        return;
      }

      // 加载GPT脚本
      await this.loadGptScript();
    },
    loadGptScript () {
      // 判断广告脚本URL是否存在
      if (!this.adsensConfig?.scriptUrl) {
        console.log('GPT脚本的URL不存在,终止加载广告外链');
        this.$eventrack('no_adscript_config', 'expose');
        return;
      }
      console.log('abababababa');

      // 检查该脚本是否已经被添加
      const existingScript = document.querySelector(`script[src="${this.adsensConfig?.scriptUrl}"]`);
      if (existingScript) {
        this.$eventrack('adscript_exist', 'expose');
        console.log('GPT脚本已存在，无需重新添加');
        this.observeAds();
        return;
      }

      console.log('准备插入GPT脚本');
      const script = document.createElement('script');
      script.src = this.adsensConfig?.scriptUrl;
      script.async = true;

      const header = document.getElementsByTagName('head')[0];
      header.appendChild(script);

      this.$eventrack('adscript_add_success', 'expose');
      script.onload = () => {
        this.initAdx();
        this.observeAds();
      };
      console.log('GPT脚本插入完成');
    },
    initAdx () {
      if (!window.googletag) {
        console.log('googletag未加载，无法初始化AdX广告');
        return;
      }

      window.googletag = window.googletag || {};
      window.googletag.cmd = window.googletag.cmd || [];

      // 初始化广告位定义
      window.googletag.cmd.push(() => {
        // 动态添加广告槽位定义
        if (this.adsensConfig?.homeAdDefinitions) {
          this.adsensConfig.homeAdDefinitions.forEach(adDef => {
            console.log(`定义广告槽位: ${adDef.slotPath}, ID: ${adDef.id}`);
            googletag.defineSlot(adDef.slotPath, adDef.sizes, adDef.id)
              .addService(googletag.pubads());
          });
        }

        // 添加插屏广告
        if (this.adsensConfig?.interstitial) {
          console.log('有插屏插屏插屏插屏插屏插屏插屏插屏插屏插屏插屏');
          try {
            const interstitialPath = this.adsensConfig.interstitial.adUnitPath;

            if (interstitialPath) {
              console.log('初始化插屏广告:', interstitialPath);
              const slot = googletag.defineOutOfPageSlot(
                interstitialPath,
                googletag.enums.OutOfPageFormat.INTERSTITIAL
              );
              console.log(slot);
              if (slot) {
                slot.addService(googletag.pubads());
                if (slot) googletag.display(slot);
              }
            }
          } catch (error) {
            console.error('初始化插屏广告失败:', error);
          }
        }

        // 添加插屏广告
        if (this.adsensConfig?.anchor) {
          console.log('有吸底吸底吸底吸底吸底吸底吸底吸底吸底');
          try {
            const anchorPath = this.adsensConfig.anchor.adUnitPath;

            if (anchorPath) {
              console.log('初始化吸底广告:', anchorPath);
              const anchorSlot = googletag.defineOutOfPageSlot(
                anchorPath,
                googletag.enums.OutOfPageFormat.BOTTOM_ANCHOR
              );
              console.log(anchorSlot);
              if (anchorSlot) {
                anchorSlot.addService(googletag.pubads());
                if (anchorSlot) googletag.display(anchorSlot);
              }
            }
          } catch (error) {
            console.error('初始化吸底广告失败:', error);
          }
        }

        // 确保服务已启用
        googletag.pubads().enableSingleRequest();
        googletag.enableServices();

        console.log('AdX广告定义完成');
      });
    },
    async displayAd (adElement) {
      await this.$nextTick();

      // AdX广告在AdComponent中已处理
      console.log('AdX广告元素已准备好:', adElement);
    },
    //广告相关end

    //ciyi

    goto (name) {
      // 显示插屏广告
      console.log('触发跳转前显示插屏广告: goto方法');
      this.showInterstitial();

      const resolved = this.$router.resolve({ name: name });
      window.location.href = resolved.href;
    },

    // 修改showInterstitial方法，确保使用const而非var
    showInterstitial () {
      console.log('尝试显示插屏广告');
      // if (!window.googletag) {
      //   console.log('googletag未加载，无法显示插屏广告');
      //   return;
      // }

      // window.googletag.cmd.push(() => {
      //   try {
      //     if (!this.adsensConfig?.interstitial?.adUnitPath) {
      //       console.log('插屏广告路径未配置');
      //       return;
      //     }

      //     console.log('定义并显示插屏广告:', this.adsensConfig.interstitial.adUnitPath);
      //     const interstitialSlot = googletag.defineOutOfPageSlot(
      //       this.adsensConfig.interstitial.adUnitPath,
      //       googletag.enums.OutOfPageFormat.INTERSTITIAL
      //     );

      //     if (interstitialSlot) {
      //       interstitialSlot.addService(googletag.pubads());
      //       googletag.display(interstitialSlot);
      //       console.log('插屏广告请求已发送');
      //     } else {
      //       console.log('插屏广告槽创建失败');
      //     }
      //   } catch (error) {
      //     console.error('显示插屏广告时出错:', error);
      //   }
      // });
    },
    observeAds () {
      const adsElements = Object.entries(this.$refs)
        .filter(([key]) => key.startsWith('ads-'))
        .flatMap(([, ref]) => ref);

      console.log('可观察的广告元素:', adsElements);

      // 如果没有找到广告元素，直接返回
      if (!adsElements || adsElements.length === 0) {
        console.log('没有找到可观察的广告元素');
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            console.log('广告元素进入可视区域:', entry.target);
            observer.unobserve(entry.target);
          }
        });
      });

      adsElements.forEach(ad => {
        // 确保ad存在
        if (!ad) {
          console.log('跳过无效的广告元素');
          return;
        }

        // 获取DOM元素
        const adElement = ad instanceof HTMLElement ? ad : (ad.$el || null);

        // 确保adElement是一个DOM元素
        if (adElement && adElement instanceof Element) {
          observer.observe(adElement);
          console.log('开始观察广告元素:', adElement);
        } else {
          console.log('无法观察非DOM元素:', ad);
        }
      });
    },
    // 添加生成Wiki URL的方法
    generateWikiUrl (id, title, category) {
      // 使用原有的chooseWiki方法中的URL生成逻辑
      const currentParams = this.$router.currentRoute.params;
      const currentQuery = this.$route.query;
      const channel = currentParams.channel ? `/${currentParams.channel}` : '';
      const queryString = new URLSearchParams(currentQuery).toString();
      const fullQueryString = queryString ? `?${queryString}` : '';

      // 这里应该使用您现有的URL生成逻辑,而不是formatName
      return `${channel}/${category}/${id}/${title.replace(/\s+/g, '-')}${fullQueryString}`;
    },

    // 添加生成Tag URL的方法
    generateTagUrl (tag) {
      // 使用原有的chooseTag方法中的URL生成逻辑
      const currentParams = this.$router.currentRoute.params;
      const currentQuery = this.$route.query;
      const channel = currentParams.channel ? `/${currentParams.channel}` : '';
      const queryString = new URLSearchParams(currentQuery).toString();
      const fullQueryString = queryString ? `?${queryString}` : '';

      // 这里应该使用您现有的URL生成逻辑
      return `${channel}/${tag}${fullQueryString}`;
    },
  }
};
</script>
